// 淘汰赛轮次标题，
// 这样使用：roundList.length-1-curIndex，比如总共5轮，当前idx为0，则标题为5-1-0，即32晋16
import { DEFAULT_GAME_PARAM_OPTIONS, GameParamMode } from '../tip-match/create/game-param';
import { TeamMemRange, VsType } from './team-mem-range';

export const elimationTabMap = {
  0: '2晋1',
  1: '4晋2',
  2: '8晋4',
  3: '16晋8',
  4: '32晋16',
};

export const boStrList = [
  '',
  '一局胜负',
  '',
  '三局两胜',
  '',
  '五局三胜',
  '',
  '七局四胜',
];


export const pickerBoList = [
  { label: '一局胜负', value: 1 },
  { label: '三局两胜', value: 3 },
  { label: '五局三胜', value: 5 },
  { label: '七局四胜', value: 7 },
];

// BP ban List
export const pickerBanList = [
  '各禁4英雄',
  '不禁用英雄',
  '',
  '各禁2英雄',
  '各禁3英雄',
];

// select ban list
export const selectBanList = [
  { label: '不禁用英雄', value: 1 },
  { label: '各禁2英雄', value: 3 },
  { label: '各禁3英雄', value: 4 },
  { label: '各禁4英雄', value: 0 },
];

// // room BP ban List desc
// export const pickerRoomBanList = {
//   0: '4Ban',
//   1: '0Ban',
//   2: '',
//   3: '2Ban',
//   4: '3Ban',
//   20001: '2Ban', // 1v1
//   20002: '0Ban', // 3v3
// };

// ban位埋点上报转换
// 0 ---> 4ban
// 1 ---> 0ban
// 2 ---> 1ban
// 3 ---> 2ban
// 4 ---> 3ban
export const banStationTrans = {
  0: 4,
  1: 0,
  3: 2,
  4: 3,
};

export { VsType };

export const FightType = {
  // 由对战方式映射出fightMode(即custom_define_id) 和 vsType(几v几)
  solo: '1v1',
  two: '2v2',
  three: '3v3',
  five: '5v5',

  cold: 'cold', // 娱乐玩法都是5v5
  seckill: 'seckill', // 娱乐玩法都是5v5
  survival: 'survival', // 娱乐玩法都是5v5
  maxed: 'maxed', // 娱乐玩法都是5v5
};
export const VsModeName = {
  [VsType.solo]: '1v1',
  [VsType.two]: '2v2',
  [VsType.three]: '3v3',
  [VsType.five]: '5v5',
  [VsType.ten]: '10v10',
};

export const FightMode = {
  none: 0,
  [FightType.cold]: 1,
  [FightType.seckill]: 2,
  [FightType.survival]: 3,
  [FightType.maxed]: 4,
};

export const FightModeName = {
  [FightMode[FightType.cold]]: '极速冷却',
  [FightMode[FightType.seckill]]: '互秒荣耀',
  [FightMode[FightType.survival]]: '极限生存',
  [FightMode[FightType.maxed]]: '一步到位',
};

export const MapImg = {
  changping: 'https://image-1251917893.file.myqcloud.com/Esports/new/admin/map-changping.jpg',
  mojia: 'https://image-1251917893.file.myqcloud.com/Esports/new/admin/map-mojia.jpg',
  xiagu: 'https://image-1251917893.file.myqcloud.com/Esports/new/admin/map-wangzhexiagu.jpg',
  zhongxing: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/map-zhongxingxiagu.jpg',
  xinxiagu: '', // TODO: 待产品提供新地图配图
};

export const FightModeDesc =  {
  [FightMode[FightType.cold]]: {
    mapName: '王者峡谷',
    img: MapImg.xiagu,
    desc: '开局1级、初始金币500、冷却缩减+80%',
    bpVal: '征召',
  },
  [FightMode[FightType.seckill]]: {
    mapName: '王者峡谷',
    img: MapImg.xiagu,
    desc: '开局5级、初始金币5000、物理/法术攻击+100%、冷却缩减+80%、小兵攻击/血量+100%、野怪攻击/血量+100%、水晶攻击/血量+100%、防御塔攻击/血量+100%',
    bpVal: '征召',
  },
  [FightMode[FightType.survival]]: {
    mapName: '王者峡谷',
    img: MapImg.xiagu,
    desc: '开局1级、 初始金币500、 无兵线、防御塔攻击/血量+100%、防御塔攻击范围+50%、野怪攻击/血量+100% ',
    bpVal: '征召',
  },
  [FightMode[FightType.maxed]]: {
    mapName: '王者峡谷',
    img: MapImg.xiagu,
    desc: '开局15级、初始金币12000',
    bpVal: '征召',
  },
};
export const PLAY_ID = {
  norm2v2: 12, // 2V2标准模式
  norm3v3: 2, // 3v3标准模式
  norm5v5: 3, // 5v5标准模式
  custom5v5: 4, // 5v5自定义赛
  random5v5: 5, // 5v5随机抽卡
  paramBuff1: 6, // 5v5极速冷却
  paramBuff2: 7, // 5v5互秒荣耀
  paramBuff3: 9, // 5v5一步到位
  quick5v5: 10, // 5v5快速赛
  customSolo: 11, // 峡谷solo赛
  custom2v2: 13, // 2V2自定义模式
  norm1v1: 14, // 1v1标准模式
  paramBuff4: 15, // 5v5极限生存
  awakening: 17, // 觉醒之战
  dreamMelee: 18, // 梦境大乱斗
  norm10v10: 19, // 10V10标准模式
  new2v2: 20, // 新2V2玩法
  infiniteMelee: 21, // 新2V2玩法
};
export function getFightModeDesc(fightMode, vsType, gameParamMode, playId) {
  if (playId === PLAY_ID.new2v2) {
    return {
      mapName: '全新峡谷地图',
      img: MapImg.xinxiagu,
    };
  }
  if (playId === PLAY_ID.awakening || playId === PLAY_ID.customSolo) {
    return {
      mapName: '王者峡谷',
      img: MapImg.xiagu,
    };
  }
  if (playId === PLAY_ID.dreamMelee) {
    return {
      mapName: '梦境大乱斗',
      img: MapImg.mojia,
    };
  }
  if (playId === PLAY_ID.infiniteMelee) {
    return {
      mapName: '无限乱斗',
      img: MapImg.xiagu,
    };
  }
  if (vsType === VsType.three) {
    return {
      mapName: '长平攻防战',
      img: MapImg.changping,
    };
  }
  if (vsType === VsType.solo) {
    return {
      mapName: '墨家机关道',
      img: MapImg.mojia,
    };
  }
  if (vsType === VsType.ten) {
    return {
      mapName: '众星峡谷',
      img: MapImg.zhongxing,
    };
  }
  if (vsType === VsType.five || vsType === VsType.two) {
    if (gameParamMode === GameParamMode.GameParamModeStandard) {
      return {
        mapName: '王者峡谷',
        img: MapImg.xiagu,
      };
    }
    const found = DEFAULT_GAME_PARAM_OPTIONS
      .concat({ value: GameParamMode.GameParamModeCustom, label: '自定义', desc: '' })
      .find(item => item.value === gameParamMode);
    const label = found?.label || '';
    return {
      mapName: label ? `王者峡谷·${label}` : '王者峡谷',
      img: MapImg.xiagu,
    };
  }
}
export const FightType2VsTpe = {
  [FightType.solo]: VsType.solo,
  [FightType.three]: VsType.three,
  [FightType.five]: VsType.five,
};

export function getVsType(fightType) {
  // 根据对战类型获取vsType(几v几)
  if ([FightType.solo, FightType.three, FightType.five].includes(fightType)) {
    return FightType2VsTpe[fightType];
  }
  return VsType.five; // 娱乐玩法都是5v5
}

export function getFightMode(fightType) {
  if ([FightType.solo, FightType.three, FightType.five].includes(fightType)) {
    return FightMode.none;
  }
  return FightMode[fightType];
}

export const VsTypeOptions = [
  {
    label: '5v5模式 · 多种模式可选择',
    text: '5v5模式',
    value: VsType.five,
    // desc: '王者峡谷', // 内容
    child: {
      label: '标准模式',
      value: GameParamMode.GameParamModeStandard,
    },
  },
  // #ifndef OVERSEAS
  {
    label: '3v3模式 · 长平攻防战',
    value: VsType.three,
    // desc: '长平攻防战',
  },
  // #endif
  {
    label: '1v1模式 · 墨家机关道',
    value: VsType.solo,
    // desc: '墨家机关道',
  },
];

export const VsTypeOptionsQuick = [
  {
    label: '5v5',
    value: VsType.five,
    desc: '王者峡谷', // 内容
  },
  // #ifndef OVERSEAS
  {
    label: '3v3',
    value: VsType.three,
    desc: '长平攻防战',
  },
  // #endif
  {
    label: '1v1',
    value: VsType.solo,
    desc: '墨家机关道',
  },
];

export const FightModeOptions = [
  {
    value: FightType.five, // 选项num
    label: '5v5', // 选项类型
    desc: '王者峡谷', // 内容
    // fightMode：值为 娱乐玩法和1v1/3v3/5v5的合集
    // vsType：表示1v1/3v3/5v5
  },
  {
    value: FightType.three,
    label: '3v3',
    desc: '长平攻防战',
  },
  {
    value: FightType.solo,
    label: '1v1',
    desc: '墨家机关道',
  },
  // {
  //   value: FightType.cold,
  //   label: '极速冷却',
  //   desc: '80%冷却缩减，无限火力10人激战',
  // },
  // {
  //   value: FightType.seckill,
  //   label: '互秒荣耀',
  //   desc: '5级开局，伤害强化，冷却缩减，樯橹间灰飞烟灭',
  // },
  // {
  //   value: FightType.survival,
  //   label: '极限生存',
  //   desc: '无兵线，防御塔和野区全面加强，击杀满30胜利',
  // },
  // {
  //   value: FightType.maxed,
  //   label: '一步到位',
  //   desc: '开局15级12000金币，一步到位决战峡谷',
  // },
].map(item => ({
  ...item,
  fightMode: getFightMode(item.value), // 值为 娱乐玩法和1v1/3v3/5v5的合集
  vsType: getVsType(item.value), // 表示几v几
}));

function getMemOption({ min, max, defaultNum }) {
  if (max <= min || min < 1) {
    return [];
  }
  return Array(max - min + 1).fill('')
    .map((item, index) => {
      const value = index + Number(min);
      return {
        label: `${value}人`,
        value,
        isDefault: defaultNum === value,
      };
    });
}

export const DefaultTeamMem = 5;

export { TeamMemRange };

export const TeamMemNumOptions = Object.entries(TeamMemRange).reduce((acc, [key, value]) => {
  acc[key] = getMemOption(value);
  return acc;
}, {});

export function initFightModeConfig(withDefault) {
  let fightMode = FightModeOptions[0].value;
  if (typeof(withDefault) !== 'undefined') {
    const fightType = getFightType(withDefault);
    const index = FightModeOptions.findIndex(item => item.value === fightType);
    if (index !== -1) {
      fightMode = FightModeOptions[index].value;
    }
  }
  return {
    options: FightModeOptions,
    title: '对战方式',
    show: false,
    value: fightMode,
    label: FightModeOptions.find(item => item.value === fightMode)?.label,
  };
}


/**
 * 把一个对象的key 和value对调生成一个新的对象
 */
export function swapKeyValue(obj = {}) {
  if (typeof obj === 'object' && obj !== null && !Array.isArray(obj)) {
    return Object.entries(obj).reduce((acc, cur) => {
      const [key, value] = cur || [];
      acc[value] = key;
      return acc;
    }, {});
  }
  return obj;
}

/**
 * 获取对战方式(fightType)
 * @param fightMode 即custom_define_id的值，表某种娱乐玩法 若为0表示非娱乐玩法
 * @param vsType  几v几
 */
export function getFightType(vsType) {
  const VsType2FightType = swapKeyValue(FightType2VsTpe);
  return VsType2FightType[vsType];
}

export const NeedPhoneNum = {
  on: 1, // 获取手机号
  off: 2, // 不获取
};

export const Switch12 = {
  // 用于数字表示的布尔变量 1表示开 2表示关 故命名为Switch12
  on: 1,
  off: 2,
};

export const QuestionType = {
  phone: 'phone',
  wx: 'wei', // 不能使用‘wx’ 会触发敏感词
  qq: 'koukou', // 不能使用 ‘qq’ 会触发敏感词
  idCardGroup: 'idcard', // 包含姓名和身份证号
};

export const QuestionTypeValue = {
  [QuestionType.phone]: '1',
  [QuestionType.wx]: '2',
  [QuestionType.qq]: '3',
};

export const UsualQuestions = [
  {
    question: '手机号',
    type: QuestionType.phone,
    id: 'phone',
    tips: '',
    require: true,
    disabled: true,
  },
  {
    question: '身份证',
    type: QuestionType.idCardGroup, // 包含姓名和身份证号
    id: 'idcard',
    tips: '请输入',
    require: true,
    disabled: true,
  },
  {
    question: '微信',
    type: QuestionType.wx,
    id: QuestionType.wx,
    tips: '请输入',
    require: false,
  },
  {
    question: 'QQ号',
    type: QuestionType.qq,
    id: QuestionType.qq,
    tips: '请输入',
    require: false,
  },
];

/**
 * 是否显示bp设置项
 * @param fightMode 即custom_define_id的值，表某种娱乐玩法 若为0表示非娱乐玩法
 * @param vsType  几v几
 */
export function calcIsShowBpSetting({ fightMode = FightMode.none, vsType = VsType.five }) {
  if (Number(vsType) === VsType.five) { // 如果是5v5
    return fightMode === FightMode.none; // 如果非娱乐玩法的5v5就显示bp设置
  }
  return false; // 1v1 3v3不显示bp设置
}

/**
 * 获取输入时间点months个月后的时间点
 * @param date 输入时间点
 * @param months months个月
 * @returns {Date} 输入时间点months个月后的时间点
 */
export function getMonthsAfter(date, months) {
  const newDate = new Date(date);
  const month = newDate.getMonth();
  newDate.setMonth(month + months);
  return new Date(newDate - (24 * 60 * 60 * 1000));
}

// 匹配赛 3v3、5v5可以选择报名方式是单人还是组队
export const ApplyType = {
  team: 1,
  single: 2,
};
// 匹配方式文案
export const ApplyTypeLabel = {
  [ApplyType.team]: '整队匹配',
  [ApplyType.single]: '单人匹配',
};
